import { render, staticRenderFns } from "./patrocinadores.vue?vue&type=template&id=502a8cc4&"
import script from "./patrocinadores.vue?vue&type=script&lang=js&"
export * from "./patrocinadores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports